const service = {
 reloadPage: () => window.location.reload(),
 removeTokensLocalStorage: () => localStorage.removeItem('tokens'),
 setTokensLocalStorage: (data) => localStorage.setItem('tokens', JSON.stringify(data)),
 setUserLocalStorage: (data) => localStorage.setItem('user', JSON.stringify(data)),

	getTokensLocalStorage: () => JSON.parse(localStorage.getItem('tokens')),
}
export default service;